module.exports = __webpack_public_path__ + "img/dd_3.ad21139c.jpg";